import React from "react";
import { Collapse, Paper } from "@mui/material";

import "./actionButtonsContainer.sass";

interface IActionButtonsContainerProps {
    showExtraOptions: boolean;
    leftBarComponent?: React.ReactNode;
    actionButtonsComponent?: React.ReactNode;
    extraOptionsComponent?: React.ReactNode;
}

export const ActionButtonsContainer: React.FC<IActionButtonsContainerProps> = ({
    showExtraOptions,
    leftBarComponent,
    actionButtonsComponent,
    extraOptionsComponent
}) => {
    return <Paper elevation={6} className="action-buttons-container">
        <Collapse in={!showExtraOptions}>
            <div className="action-buttons-info">
                <div>
                    {leftBarComponent}
                </div>
                {actionButtonsComponent}
            </div>
        </Collapse>
        <Collapse in={showExtraOptions}>
            {extraOptionsComponent}
        </Collapse>
    </Paper>;
};
